import { useEffect, useState } from "react";
import { t } from "@/i18n-js/instance";
import ali1x from "@circle-assets/images/onboarding/ali@1x.jpg";
import ali2x from "@circle-assets/images/onboarding/ali@2x.jpg";
import dana1x from "@circle-assets/images/onboarding/dana@1x.jpg";
import dana2x from "@circle-assets/images/onboarding/dana@2x.jpg";
import tiago1x from "@circle-assets/images/onboarding/tiago@1x.jpg";
import tiago2x from "@circle-assets/images/onboarding/tiago@2x.jpg";

export interface ImageVariants {
  large: string;
  medium: string;
  small: string;
  thumbnail: string;
}

export interface Testimonial {
  author: string;
  content: string;
  image: string;
  imageVariants: ImageVariants;
  index: number;
  role: string;
}

export const ROTATION_INTERVAL = 7000; // 7 seconds
const LOCALE_SCOPE = "authentication_app.new_onboarding_flow_april_2025";

// Helper function to create image variants from base name
const createImageVariants = (baseName: string): ImageVariants => {
  switch (baseName) {
    case "tiago":
      return {
        thumbnail: tiago1x,
        small: tiago1x,
        medium: tiago2x,
        large: tiago2x,
      };
    case "ali":
      return {
        thumbnail: ali1x,
        small: ali1x,
        medium: ali2x,
        large: ali2x,
      };
    case "dana":
      return {
        thumbnail: dana1x,
        small: dana1x,
        medium: dana2x,
        large: dana2x,
      };
    default:
      return { thumbnail: "", small: "", medium: "", large: "" };
  }
};

export const testimonials: Testimonial[] = [
  {
    index: 0,
    image: tiago2x,
    imageVariants: createImageVariants("tiago"),
    content: t(`${LOCALE_SCOPE}.testimonials.tiago.content`),
    author: t(`${LOCALE_SCOPE}.testimonials.tiago.author`),
    role: t(`${LOCALE_SCOPE}.testimonials.tiago.role`),
  },
  {
    index: 1,
    image: ali2x,
    imageVariants: createImageVariants("ali"),
    content: t(`${LOCALE_SCOPE}.testimonials.ali.content`),
    author: t(`${LOCALE_SCOPE}.testimonials.ali.author`),
    role: t(`${LOCALE_SCOPE}.testimonials.ali.role`),
  },
  {
    index: 2,
    image: dana2x,
    imageVariants: createImageVariants("dana"),
    content: t(`${LOCALE_SCOPE}.testimonials.dana.content`),
    author: t(`${LOCALE_SCOPE}.testimonials.dana.author`),
    role: t(`${LOCALE_SCOPE}.testimonials.dana.role`),
  },
];

export const useTestimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex(current => (current + 1) % testimonials.length);
    }, ROTATION_INTERVAL);

    return () => clearInterval(interval);
  }, []);

  return {
    currentTestimonial: testimonials[currentIndex],
  };
};
